define(["require", "exports", "tslib", "esri/core/accessorSupport/decorators", "esri/widgets/support/widget", "esri/widgets/Feature", "esri/core/Handles", "./Accordion", "esri/tasks/RouteTask", "esri/tasks/support/RouteParameters", "esri/tasks/support/FeatureSet", "esri/Graphic", "../utilites/geometryUtils", "esri/geometry", "esri/symbols", "esri/layers/FeatureLayer", "esri/geometry"], function (require, exports, tslib_1, decorators_1, widget_1, Feature_1, Handles_1, Accordion_1, RouteTask_1, RouteParameters_1, FeatureSet, Graphic_1, geometryUtils_1, geometry_1, symbols_1, FeatureLayer_1, geometry_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Feature_1 = tslib_1.__importDefault(Feature_1);
    Handles_1 = tslib_1.__importDefault(Handles_1);
    Accordion_1 = tslib_1.__importDefault(Accordion_1);
    RouteTask_1 = tslib_1.__importDefault(RouteTask_1);
    RouteParameters_1 = tslib_1.__importDefault(RouteParameters_1);
    Graphic_1 = tslib_1.__importDefault(Graphic_1);
    FeatureLayer_1 = tslib_1.__importDefault(FeatureLayer_1);
    var CSS = {
        base: 'accordion',
        basejs: 'js-accordion',
        single: 'single',
        section: 'accordion-section',
        groupSection: 'group-accordion-section',
        active: 'is-active',
        title: 'accordion-title',
        titleArea: 'title-area',
        count: 'group-accordion-count',
        content: 'accordion-content',
        contentButton: 'accordion-content-button',
        groupContent: 'group-accordion-content',
        featureGroup: 'feature-group',
        button: 'btn',
        transparentButton: 'btn-transparent',
        clearButton: "btn-clear",
        modalButton: "js-modal-toggle",
        smallButton: 'btn-small',
        accordionIcon: 'accordion-icon',
        groupAccordionIcon: 'group-accordion-icon',
        paddingTrailer: 'padding-right-quarter',
        right: 'right',
        actions: 'accordion-actions',
        templateContent: 'template',
        scrollable: "scrollable-content",
    };
    var GroupedAccordion = /** @class */ (function (_super) {
        tslib_1.__extends(GroupedAccordion, _super);
        //--------------------------------------------------------------------------
        //
        //  Public Methods
        //
        //--------------------------------------------------------------------------
        function GroupedAccordion(props) {
            var _this = _super.call(this, props) || this;
            //--------------------------------------------------------------------------
            //
            // Variables
            //
            //--------------------------------------------------------------------------
            _this._calciteLoaded = false;
            _this._handles = new Handles_1.default();
            _this._featureCount = 0;
            _this._routeReady = false;
            _this._routeDirections = [];
            _this._csLocationImg = "";
            _this._directionsError = false;
            console.log("Create Grouped Accordion");
            if (props.featureResults) {
                console.log("Create", props.featureResults);
                props.featureResults.forEach(function (result) {
                    _this._featureCount += result.features && result.features.length;
                });
            }
            return _this;
        }
        GroupedAccordion.prototype.render = function () {
            var _this = this;
            return (widget_1.tsx("div", { key: "feature-container", afterCreate: this.updateCalcite },
                widget_1.tsx("div", { class: this.classes(CSS.base, CSS.basejs, CSS.scrollable) }, this.featureResults &&
                    this.featureResults.map(function (result, i) { return _this._createSections(result, i); }))));
        };
        GroupedAccordion.prototype._createSections = function (result, key) {
            var _this = this;
            var count = result.features && result.features.length;
            var classes = count === 1 ? [CSS.section, CSS.single, CSS.groupSection] : [CSS.section, CSS.groupSection];
            // Open section if its the first section or if there is only one feature in the section
            if (count === 1 || key === 0) {
                classes.push(CSS.active);
            }
            return (widget_1.tsx("section", { bind: this, key: "section" + key, class: this.classes(classes) },
                widget_1.tsx("h5", { class: CSS.title },
                    widget_1.tsx("span", { class: CSS.titleArea },
                        result.title,
                        widget_1.tsx("span", { class: this.classes(CSS.accordionIcon, CSS.groupAccordionIcon, CSS.paddingTrailer) },
                            widget_1.tsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 32 32", class: "svg-icon" },
                                widget_1.tsx("path", { d: "M28 9v5L16 26 4 14V9l12 12L28 9z" }))))),
                widget_1.tsx("ul", { role: 'group', class: this.classes(CSS.templateContent, CSS.content, CSS.groupContent) }, result.features &&
                    result.features.map(function (feature, i) {
                        return (widget_1.tsx("div", null,
                            widget_1.tsx("button", { class: _this.classes(CSS.contentButton, CSS.button, CSS.clearButton), "data-feature-button": feature, bind: _this, afterCreate: _this._createFeatureButton }, "Zoom to Court District"),
                            widget_1.tsx("br", null),
                            widget_1.tsx("li", { role: 'menuitem', tabindex: "0", "data-feature": feature, afterCreate: _this._createFeature, class: _this.classes(CSS.featureGroup), bind: _this, key: "feature" + i }),
                            widget_1.tsx("br", null),
                            widget_1.tsx("button", { class: _this.classes([CSS.contentButton, CSS.button, CSS.clearButton, CSS.modalButton]), "data-feature-route": { "location": result.location, "feature": feature }, bind: _this, afterCreate: _this._createRouteButton }, "Show Directions"),
                            _this._directionsError && widget_1.tsx("span", { style: "color:red" }, "\u00A0\u00A0\u00A0\u00A0Error getting direcitons. Please try again later."),
                            widget_1.tsx("br", null),
                            widget_1.tsx("br", null),
                            _this._routeReady && widget_1.tsx("div", null,
                                widget_1.tsx("span", null, "Directions"),
                                widget_1.tsx("ul", null, _this._routeDirections.map(function (rt, i) {
                                    return (widget_1.tsx("li", { key: i }, rt));
                                })))));
                    }))));
        };
        GroupedAccordion.prototype._createCourthouseImages = function (graphic) {
            this._csLocationImg = "";
            return (new FeatureLayer_1.default({ url: graphic.layer["url"] + "/1" }).queryAttachments({
                "objectIds": [graphic.attributes["CCGIS.SmallClaimsCourt_Table.OBJECTID"]]
            }).then(function (atts) {
                return atts;
            }).catch(function (error) {
                console.log(error);
            }));
        };
        GroupedAccordion.prototype._createRouteButton = function (node) {
            var _this = this;
            this._directionsError = false;
            var startStopData = node['data-feature-route'];
            node.addEventListener("click", function () {
                _this._directionsError = false;
                node.innerHTML = "Please wait...";
                node.setAttribute("disabled", "disabled");
                if (_this._routeReady == true) {
                    _this.set("_routeReady", false);
                    node.innerHTML = "Show Directions";
                    _this.view.graphics.removeAt(_this.view.graphics.length - 1);
                    node.removeAttribute("disabled");
                    return;
                }
                _this._routeDirections = [];
                var routeTask = new RouteTask_1.default({
                    url: "//xmaps.indy.gov/arcgis/rest/services/Routing/Routing/NAServer/Route"
                });
                var routeParams = new RouteParameters_1.default({
                    stops: new FeatureSet(),
                    outSpatialReference: _this.view.spatialReference
                });
                var startPoint = new geometry_1.Point({
                    x: startStopData.location.geometry.type == "polygon" ? startStopData.location.geometry.centroid.x : startStopData.location.geometry.type == "point" ? startStopData.location.geometry.x : null,
                    y: startStopData.location.geometry.type == "polygon" ? startStopData.location.geometry.centroid.y : startStopData.location.geometry.type == "point" ? startStopData.location.geometry.y : null,
                    spatialReference: startStopData.location.geometry.spatialReference
                });
                var stopPoint = new geometry_1.Point({
                    x: startStopData.feature.attributes["CCGIS.SmallClaimsCourt_Table.COURTHOUSE_X"],
                    y: startStopData.feature.attributes["CCGIS.SmallClaimsCourt_Table.COURTHOUSE_Y"],
                    spatialReference: new geometry_2.SpatialReference({ wkid: 2244 })
                });
                var projectPointPromises = [];
                if (startPoint.spatialReference == _this.view.spatialReference) {
                    projectPointPromises.push(Promise.resolve(startPoint));
                }
                else {
                    projectPointPromises.push(geometryUtils_1.projectPoint(startPoint, _this.view.spatialReference).then(function (projectedPoint) { return projectedPoint; }));
                }
                projectPointPromises.push(geometryUtils_1.projectPoint(stopPoint, _this.view.spatialReference).then(function (projectedPoint) {
                    return projectedPoint;
                }));
                Promise.all(projectPointPromises).then(function (projectedPoints) {
                    var start = new Graphic_1.default({
                        geometry: projectedPoints[0],
                        attributes: { "Name": startStopData.location.attributes["FullAddress"] }
                    });
                    var stop = new Graphic_1.default({
                        geometry: projectedPoints[1],
                        attributes: { "Name": startStopData.feature.attributes["CCGIS.SmallClaimsCourt_Table.COURTHOUSE_ADDRESS"] }
                    });
                    routeParams.stops["features"].push(start);
                    routeParams.stops["features"].push(stop);
                    routeParams.impedanceAttribute = "Seconds";
                    routeParams.returnDirections = true;
                    routeTask.solve(routeParams).then(function (route) {
                        if (route["routeResults"][0].directions) {
                            route["routeResults"][0].directions.features.forEach(function (f) {
                                _this._routeDirections.push(f.attributes["text"]);
                            });
                            _this.set("_routeReady", true);
                            var routeGraphic = route["routeResults"][0].route;
                            routeGraphic.symbol = new symbols_1.SimpleLineSymbol({
                                color: 'red',
                                width: 5
                            });
                            _this.view.graphics.add(routeGraphic);
                        }
                        node.innerHTML == "Hide Directions" ? node.innerHTML = "Show Directions" : node.innerHTML = "Hide Directions";
                        node.removeAttribute("disabled");
                        _this._directionsError = false;
                    }).catch(function (err) {
                        node.innerHTML = "Show Directions";
                        node.removeAttribute("disabled");
                        _this._directionsError = true;
                    });
                });
            });
        };
        GroupedAccordion.prototype._createFeatureButton = function (node) {
            var _this = this;
            var graphic = node['data-feature-button'];
            node.addEventListener("click", function () {
                _this.selectedItem = graphic;
                // if(graphic.layer.visible == false){
                //     graphic.layer.visible = true;
                // }
                // node.innerHTML == "Hide Court District" ? node.innerHTML = "Show Court District" : node.innerHTML = "Hide Court District"
            });
        };
        GroupedAccordion.prototype._createFeature = function (node) {
            var _this = this;
            var graphic = node['data-feature'];
            var courtHouseMediaContent = null;
            this._createCourthouseImages(graphic).then(function (atts) {
                var courthouseImages = [];
                if (atts[graphic.attributes["CCGIS.SmallClaimsCourt_Table.OBJECTID"]]) {
                    atts[graphic.attributes["CCGIS.SmallClaimsCourt_Table.OBJECTID"]].forEach(function (element) {
                        courthouseImages.push(graphic.layer["url"] + "/1/" + graphic.attributes["CCGIS.SmallClaimsCourt_Table.OBJECTID"] + "/attachments/" + element.id);
                    });
                }
                if (courthouseImages.length > 0) {
                    var courtHouseMediaInfos_1 = [];
                    courthouseImages.forEach(function (chImage) {
                        courtHouseMediaInfos_1.push({
                            title: "<b>Photo:</b>",
                            type: "image",
                            caption: graphic.attributes["CCGIS.SmallClaimsCourt_Table.COURTHOUSE_NAME"],
                            value: {
                                sourceURL: chImage
                            }
                        });
                    });
                    courtHouseMediaContent = {
                        type: "media",
                        mediaInfos: courtHouseMediaInfos_1
                    };
                }
                _this._completeFeatureCreation(node, graphic, courtHouseMediaContent);
            }).catch(function (err) {
                _this._completeFeatureCreation(node, graphic, courtHouseMediaContent);
            });
        };
        GroupedAccordion.prototype._completeFeatureCreation = function (node, graphic, courtHouseMediaContent) {
            var _this = this;
            var graphicPopupTemplate = graphic.layer.popupTemplate.clone();
            courtHouseMediaContent && graphicPopupTemplate.content.push(courtHouseMediaContent);
            graphic.popupTemplate = graphicPopupTemplate;
            var titleNode = document.createElement("div");
            node.appendChild(titleNode);
            var container = document.createElement("div");
            var feature = new Feature_1.default({
                graphic: graphic,
                defaultPopupTemplateEnabled: true,
                map: this.view.map,
                spatialReference: this.view.spatialReference,
                visibleElements: {
                    title: false
                },
                container: container
            });
            node.appendChild(container);
            var handle = feature.watch('title', function () {
                var title = feature.get('title');
                handle.remove();
                if (graphic && graphic.attributes && graphic.attributes.lookupDistance && _this.config.includeDistance) {
                    titleNode.innerHTML += _this.convertUnitText(graphic.attributes.lookupDistance, _this.config.units);
                }
                else {
                    titleNode.innerHTML = title;
                }
            });
            this.selectedItem = graphic;
            // let clonedGraphic = graphic.clone();
            // const handleFomattedAttributes = feature?.viewModel?.watch("formattedAttributes", () => {
            //     handleFomattedAttributes.remove();
            //     let formattedAttrsGlobal = feature.viewModel.formattedAttributes.global;
            //     let expressionInfos = {};
            //     for(let ei of feature.viewModel.graphic.popupTemplate.expressionInfos){
            //         expressionInfos[ei.name] = ei.title;
            //     }
            //     let friendlyNameAttrs = {};
            //     for (let key in formattedAttrsGlobal){
            //         if(key.indexOf('expression/') == -1){
            //             friendlyNameAttrs[key] = formattedAttrsGlobal[key];
            //         }else{
            //             friendlyNameAttrs[expressionInfos[key.split('/')[1]]] = formattedAttrsGlobal[key];
            //         }
            //     }
            //     console.log(friendlyNameAttrs);
            //     clonedGraphic.attributes = friendlyNameAttrs;
            //     this.selectedItem = clonedGraphic;
            // });        
        };
        GroupedAccordion.prototype.clear = function () {
            // this.featureResults?.forEach(element => {
            //     element.features.forEach(feature => {
            //         (feature.layer as esri.FeatureLayer).definitionExpression = null;
            //         if(feature.layer.visible == true){
            //             feature.layer.visible = false;
            //         }
            //     });
            // });
            this.featureResults = null;
        };
        GroupedAccordion.prototype.showToggle = function () {
            // show toggle buttons if we have more than 2 sections? 
            return this.featureResults && this.featureResults.length && this.featureResults.length > 2;
        };
        tslib_1.__decorate([
            decorators_1.property()
        ], GroupedAccordion.prototype, "featureResults", void 0);
        tslib_1.__decorate([
            decorators_1.property(),
            widget_1.renderable()
        ], GroupedAccordion.prototype, "_routeReady", void 0);
        tslib_1.__decorate([
            decorators_1.property(),
            widget_1.renderable()
        ], GroupedAccordion.prototype, "_routeDirections", void 0);
        tslib_1.__decorate([
            decorators_1.property(),
            widget_1.renderable()
        ], GroupedAccordion.prototype, "_csLocationImg", void 0);
        tslib_1.__decorate([
            decorators_1.property(),
            widget_1.renderable()
        ], GroupedAccordion.prototype, "_directionsError", void 0);
        GroupedAccordion = tslib_1.__decorate([
            decorators_1.subclass('app.GroupedAccordion')
        ], GroupedAccordion);
        return GroupedAccordion;
    }((Accordion_1.default)));
    exports.default = GroupedAccordion;
});
//# sourceMappingURL=GroupedAccordion.js.map